import React from 'react'
import { Link } from 'react-router-dom'
import { FaServer } from "react-icons/fa";
import { MdOutlineHome } from "react-icons/md";
import { useLocation } from 'react-router-dom';

export const AdminNav = () => {
    const { pathname } = useLocation();
    function getDate() {
        const today = new Date();
        let month = today.toLocaleString('default', { month: 'long' });
        month = month.substring(0, 3);
        let date = today.getDate();
        date = date < 10 ? `0${date}` : date;
        const day = today.toLocaleString('default', { weekday: 'long' });
        return `${day}, ${month} ${date}`;
    }
    function getTime() {
        const today = new Date();
        let hours = today.getHours();
        let minutes = today.getMinutes();
        minutes = minutes < 10 ? `0${minutes}` : minutes;
        const m = hours >= 12 ? 'PM' : 'AM';
        hours = hours % 12;
        if (hours === 0) hours = 12;
        return `${hours}:${minutes} ${m}`;
    }
    const date = getDate();
    const time = getTime();
    return (
        <nav className='flex justify-between pt-[10px] px-[10px] font-bold'>
            <div className='flex min-h-fit'>
                <div className={`home p-[10px] h-full rounded-t-xl ${pathname.includes("/admin") ? 'bg-[#f5f5f5] text-blue-500' : ''}`}>
                    <Link to={"/admin"} >
                        <MdOutlineHome className={` text-3xl`} />
                    </Link>
                </div>
                <div className={`service p-[10px] h-full rounded-t-xl ${pathname.includes("/clinics") ? 'bg-[#f5f5f5] text-blue-500' : ''}`}>
                    <Link to={"/clinics"}>
                        <FaServer className={`text-3xl`} />
                    </Link>
                </div>
            </div>
            <div>
                {date}
                <br />
                {time}
            </div>
        </nav>
    )
}
